import React from "react";
import { string, object } from "prop-types";
import { Tag } from "antd";
import { getSelectionGroupStyle } from "../../utils/selectionGroups";

// Color-coded tag for a campaign selection group; the color is derived from the handle.
export default function SelectionGroupTag({ group, style }) {
  return (
    <Tag style={{ ...getSelectionGroupStyle(group), marginRight: 0, ...style }}>
      {group}
    </Tag>
  );
}

SelectionGroupTag.propTypes = {
  group: string,
  style: object,
};
